module.exports = __webpack_public_path__ + "static/media/Colle_HH.a32e2301.svg";